// Shared FPS tuning — used by client (prediction/render) and server
// (authoritative combat/respawn). Keep these in one place so both sides
// agree on damage, speed, and timings.

export enum Team {
  T = 0, // Terrorists — orange
  CT = 1, // Counter-Terrorists — blue
}

export const TEAM_COLOR: Record<Team, number> = {
  [Team.T]: 0xff8c2b, // orange (matches the VECK.io reference)
  [Team.CT]: 0x2b6cff, // blue
};

export const TEAM_NAME: Record<Team, string> = {
  [Team.T]: "Laranja",
  [Team.CT]: "Azul",
};

// ─── Player / movement ───
export const FPS_PLAYER_HEIGHT = 1.8; // eye stands ~1.7
export const FPS_PLAYER_EYE = 1.65;
export const FPS_PLAYER_RADIUS = 0.4; // AABB half-width for collision
export const FPS_WALK_SPEED = 5.2;
export const FPS_SPRINT_SPEED = 8.0;
export const FPS_CROUCH_SPEED = 2.6;
export const FPS_CROUCH_EYE = 1.05;
export const FPS_JUMP_VELOCITY = 7.2;
export const FPS_GRAVITY = 20;
export const FPS_MAX_FALL = 60;

// ─── Health / combat ───
export const FPS_MAX_HP = 100;
export const FPS_RESPAWN_MS = 3000;
export const HEADSHOT_MULTIPLIER = 2.0;
// Vertical bands (feet-relative) that count as a headshot when a ray hits
// a player. Above this fraction of height = head.
export const HEAD_ZONE_FROM = 0.82;

// ─── Weapon spec (catalog lives in weapons.ts) ───
export type WeaponClass = "rifle" | "pistol" | "sniper";

export type WeaponSpec = {
  id: string;
  name: string;
  class: WeaponClass;
  auto: boolean; // hold to fire vs click-per-shot
  damage: number; // body damage per bullet
  rpm: number; // rounds per minute (cadence)
  magSize: number;
  reserveAmmo: number; // spare rounds carried outside the mag
  reloadMs: number;
  range: number; // hitscan max distance (world units)
  spreadHip: number; // radians of random cone from the hip / moving
  spreadAds: number; // radians when aiming down sights
  recoilKick: number; // radians of upward camera kick per shot
  adsFov: number; // camera FOV while aiming (lower = more zoom)
};

// ─── Match ───
export const SCORE_LIMIT = 50; // team deathmatch: first team to N kills wins
